import { render, staticRenderFns } from "./SelectCtrPlc2.vue?vue&type=template&id=bdaa6aae"
import script from "./SelectCtrPlc2.vue?vue&type=script&lang=js"
export * from "./SelectCtrPlc2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdaa6aae')) {
      api.createRecord('bdaa6aae', component.options)
    } else {
      api.reload('bdaa6aae', component.options)
    }
    module.hot.accept("./SelectCtrPlc2.vue?vue&type=template&id=bdaa6aae", function () {
      api.rerender('bdaa6aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/SelectCtrPlc2.vue"
export default component.exports